import './index.css';

import { ConnectedRouter } from 'connected-react-router';
import { getStore } from 'exacta-material-react/lib/src/store';
import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import { ThemeProvider as MuThemeProvider } from '@material-ui/core/styles';

import App from './containers/App';
import history from './helpers/history';
import createLogger, { LoggerColumns } from './helpers/logger';
import i18n, { defaultLanguage } from './i18n';
import * as serviceWorker from './serviceWorker';
import reducers from './store/reducers/index.reducer';
import sagas from './store/sagas';
import MItheme from './themes/materialTheme';
import theme from './themes/theme';
import { ElectronConfig, NOTSElectronAPI } from './types/ElectronConfig';

const Logger = createLogger('src/index.tsx', {
  columns: [LoggerColumns.REDUX],
  tags: ['redux'],
});

declare global {
  interface Window {
    Nots: any;
    executor: any;
    NotsElectron: NOTSElectronAPI;
    __configFromElectron: ElectronConfig;
  }
}

export const initialState = {
  locale: {
    lang: defaultLanguage,
  },
};
const MOUNT_NODE = document.getElementById('root');

if (MOUNT_NODE) {
  ReactDOM.render(
    <Provider
      store={getStore({
        reducers,
        sagas,
        persistState: true,
        saveStateKeys: ['authenticate', 'executor', 'process', 'resources'],
        initialState,
        // Disable redux logging temporarily, socket crashes with too much data.
        // Need to implement chunking of data before enabling again.
        // logger: Logger,
      })}
    >
      <ConnectedRouter history={history}>
        <MuThemeProvider theme={MItheme}>
          <ThemeProvider theme={theme}>
            <Suspense fallback={<div>Loading...</div>}>
              <>
                <I18nextProvider i18n={i18n}>
                  <App />
                </I18nextProvider>
              </>
            </Suspense>
          </ThemeProvider>
        </MuThemeProvider>
      </ConnectedRouter>
    </Provider>,
    MOUNT_NODE
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
